var map = {
	"./arrow.png": "b9c6",
	"./back.png": "8cdc",
	"./background.png": "0bca",
	"./black-dot.png": "f93c",
	"./close.png": "1d7c",
	"./crystal-2.png": "2e71",
	"./crystal.png": "aaf3",
	"./desktop/background.png": "b820",
	"./desktop/down.png": "8b96",
	"./desktop/image.png": "cc4e",
	"./desktop/iphone.png": "5ec9",
	"./desktop/map.png": "d701",
	"./desktop/poster.png": "6c5d",
	"./desktop/small-iphone.png": "0d48",
	"./expand.png": "ed97",
	"./location.png": "f599",
	"./logo.png": "a4d7",
	"./logos/bixi.png": "68c7",
	"./logos/calq.png": "7bf4",
	"./logos/cca_en.png": "71ab",
	"./logos/cca_fr.png": "dfcd",
	"./logos/mtl.jpg": "8326",
	"./logos/rbc.png": "c114",
	"./marker.png": "3b30",
	"./place.png": "d9a8",
	"./point.png": "de37",
	"./reflect.png": "bff0",
	"./troubles.png": "bf75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b33";